import tw from "twin.macro"

export const Wrapper = tw.div`
  max-w-xl mx-auto md:px-3 py-3-2 md:py-8 
`
